import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomLayout from "../../../Core/Layout/CustomLayout";
import NestedNameDropdown from "./NestedNameDropdown";
import { EnergyPredictionKPI, EnergyStorageKPI, SolarPanelKPI } from "./KPIs";
import { TIME_FILTER } from "../constants";
import EnergyConsumption from "./EnergyConsumption";
import EnergyDistribution from "./EnergyDistribution";
import {
  getEnergyPrediction,
  getHubDetailEnergyConsumption,
  getHubDetailKPIs,
  getLineChart,
} from "../../../Redux/APIs/hubAPI";
import ToastMessageModal from "./ToasMessageModal";
import { updateHub } from "../../../Redux/Slices/hubs.slice";

const HubDetailScreen = () => {
  const dispatch = useDispatch();

  const { id } = useParams();

  const { detailsToastMessage, hubDetailsEnergyConsumption } = useSelector(
    (state) => state.hubs,
  );

  const [kpiTimeFilter, setKpiTimeFilter] = useState({
    id: TIME_FILTER.TODAY,
    value: "today",
    custom: [],
  });

  const [energyDistributionButton, setEnergyDistributionButton] = useState({});

  const [energyDistributionTimeFilter, setEnergyDistributionTimeFilter] =
    useState({
      id: TIME_FILTER.TODAY,
      value: "today",
      custom: [],
    });

  // fetch the hub details kpi and energy consumption
  useEffect(() => {
    const filterObj = {
      // hubId: +id,
      dateFilterType: kpiTimeFilter.id,
      custom: kpiTimeFilter.custom,
    };

    // selected filter is not custom
    if (kpiTimeFilter.id !== TIME_FILTER.CUSTOM) {
      dispatch(getHubDetailKPIs({ ...filterObj, hubId: +id }));
      dispatch(getHubDetailEnergyConsumption(filterObj));
    }

    // selected filter is custom
    if (
      kpiTimeFilter.id === TIME_FILTER.CUSTOM &&
      kpiTimeFilter.custom.length === 2
    ) {
      dispatch(getHubDetailKPIs({ ...filterObj, hubId: +id }));
      dispatch(getHubDetailEnergyConsumption(filterObj));
    }
  }, [dispatch, id, kpiTimeFilter]);

  // get the energy prediction
  useEffect(() => {
    dispatch(getEnergyPrediction({ hubId: +id }));
  }, [dispatch, id]);

  // fetch the line chart data
  useEffect(() => {
    if (id && energyDistributionButton?.id && energyDistributionButton?.name) {
      const filterObj = {
        hubId: +id,
        energyConsumptionId: energyDistributionButton.id,
        energyConsumptionName: energyDistributionButton.name,
        dateFilterType: energyDistributionTimeFilter.id,
        custom: energyDistributionTimeFilter.custom,
      };

      // selected filter is not custom
      if (energyDistributionTimeFilter.id !== TIME_FILTER.CUSTOM) {
        dispatch(getLineChart(filterObj));
      }

      // selected filter is custom
      if (
        energyDistributionTimeFilter.id === TIME_FILTER.CUSTOM &&
        energyDistributionTimeFilter.custom.length === 2
      ) {
        dispatch(getLineChart(filterObj));
      }
    }
  }, [dispatch, id, energyDistributionTimeFilter, energyDistributionButton]);

  // update the energy distribution button
  useEffect(() => {
    const first = hubDetailsEnergyConsumption[0];
    setEnergyDistributionButton(first);
  }, [hubDetailsEnergyConsumption]);

  // close the toast message after 5 seconds
  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(
        updateHub({
          key: "detailsToastMessage",
          value: {
            visible: false,
            data: {},
          },
        }),
      );
    }, 5000);

    return () => clearTimeout(timeout);
  }, [dispatch, detailsToastMessage]);

  return (
    <CustomLayout
      nestedName
      pageName="Hubs"
      customNestedName={<NestedNameDropdown />}
    >
      <div className="bg-background flex flex-col gap-y-6 p-6 h-[calc(100vh-72px-40px)] overflow-y-scroll">
        <div className="flex items-center gap-x-6">
          <SolarPanelKPI
            timeFilter={kpiTimeFilter}
            setTimeFilter={setKpiTimeFilter}
          />

          <EnergyStorageKPI />

          <EnergyPredictionKPI />
        </div>

        <EnergyConsumption />

        <EnergyDistribution
          timeFilter={energyDistributionTimeFilter}
          setTimeFilter={setEnergyDistributionTimeFilter}
          energyDistributionButton={energyDistributionButton}
          setEnergyDistributionButton={setEnergyDistributionButton}
        />

        <ToastMessageModal
          visible={detailsToastMessage?.visible}
          onCancel={() =>
            dispatch(
              updateHub({
                key: "detailsToastMessage",
                value: {
                  visible: false,
                  data: {},
                },
              }),
            )
          }
          title={detailsToastMessage?.data?.title}
          description={detailsToastMessage?.data?.description}
        />
      </div>
    </CustomLayout>
  );
};

export default HubDetailScreen;
